import { useStoreWithEqualityFn } from 'zustand/traditional';
import { createStore } from 'zustand/vanilla';
export { shallow } from 'zustand/shallow';
export { createStore, useStoreWithEqualityFn };
/**
 * Subscribes a component to one derived value of a vanilla store. The selector decides what it
 * re-renders on: a primitive re-renders only when that primitive changes; a freshly built object
 * needs `shallow`, or it re-renders on every write.
 */
export function useStoreSelector(store, select, equals = Object.is) {
    return useStoreWithEqualityFn(store, select, equals);
}
